import React from 'react';
import AddEdit from '../Transition/AddEdit';
import { useQuery } from '../../utils/helper';
import { apiBatchRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { ShowToast } from '../../utils/toast-service';

class PTFDetail extends React.PureComponent {
	// COnstructor to define initial state
    constructor(props) {
      super(props);
      const query = useQuery();
      const prmSelectedTransitionId = query.get('selectedTransitionId');
      const prmReadOnly = query.get('readOnly');
      const prmSelectedPropertyId = query.get('selectedPropertyId');
      const prmSelectedClientId = query.get('selectedClientId');
      const prmIsCallFromPTFDetailReport = query.get('isCallFromPTFDetailReport');

			this.state = {
        selectedTransitionId: prmSelectedTransitionId,
        readOnly: (prmReadOnly === true || prmReadOnly === 'true' || prmReadOnly === '1') ? true : false,
        selectedPropertyId: prmSelectedPropertyId,
        selectedClientId: prmSelectedClientId,
        isCallFromPTFDetailReport: (prmIsCallFromPTFDetailReport === true || prmIsCallFromPTFDetailReport === 'true' || prmIsCallFromPTFDetailReport === '1') ? true : false,
        propertyMasterData: [],
        serviceTypeMasterData: [],
      };
    }

		// Methos is called before components are rendered. This method is used to load master data required for filter source.
    componentDidMount() {
      this.GetMasterData();
    }

		// This method is used to load master data required for filter source.
    GetMasterData()
    {
      this._asyncRequest = apiBatchRequest([
        {
          url: API_URL.Assignments.GetServiceTypeMasterData + '?outputType=ListAll',
          key: 'serviceTypeAllMasterData',
          fromCache: false,
          duration: 60
        },
        {
          url: API_URL.Property.GetPropertyMasterData,
          key: 'propertyMasterData',
        }               
      ]).then(
        ({
          serviceTypeAllMasterData,            
          propertyMasterData
        }) => {          
          this._asyncRequest = null;
          if (serviceTypeAllMasterData.success === true) {
            this.setState(
              {
                propertyMasterData: propertyMasterData.data || [],
                serviceTypeAllMasterData: serviceTypeAllMasterData.data || [],
              }
            );
          } else {
            this.setState({ isLoading: false });
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
        }
      );
    }

		// Render method to render the components based on conditions. It will render the PTF Details view
    render() {
    	const {selectedTransitionId, selectedPropertyId, selectedClientId, isCallFromPTFDetailReport, readOnly, propertyMasterData, serviceTypeAllMasterData} = this.state;
      return(
        (serviceTypeAllMasterData || []).length > 0 && (
          <AddEdit 
            selectedTransitionId= {selectedTransitionId}
            selectedPropertyId= {selectedPropertyId}
            selectedClientId= {selectedClientId}
            isCallFromPTFDetailReport={isCallFromPTFDetailReport}
            readOnly= {readOnly}
            propertyMasterData={propertyMasterData}
            serviceTypeMasterData={serviceTypeAllMasterData}
            serviceTypeAllMasterData={serviceTypeAllMasterData}
          />
          )            
      );
    }
}

export default PTFDetail;